import {
  faCircleQuestion,
  faListCheck,
  faPlus
} from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useContext } from 'react'
import { ButtonGroup } from '~/components/Global/Blocks/ButtonGroup/ButtonGroup'
import { Tooltip } from '~/components/Global/Elements/Tooltip/Tooltip'
import {
  Button,
  ButtonVariation
} from '~/components/Global/Interactions/Button'
import {
  HeaderActions,
  HeaderIcon,
  HeaderTitle,
  PageHeader
} from '~/components/Layout/Page'
import { TaskAction } from '~/domains/tasks/components/TaskAction/TaskAction'
import { AsideActionContext } from '~/utils/contextes'

type HeaderProps = {
  onStartTour: () => void
}

export const Header = ({ onStartTour }: HeaderProps) => {
  const { setAsideAction } = useContext(AsideActionContext)

  return (
    <PageHeader>
      <HeaderTitle>
        <HeaderIcon icon={faListCheck} />
        Tâches
      </HeaderTitle>
      <HeaderActions>
        <ButtonGroup align="right">
          <Tooltip text="Découvrir la page Tâches" direction="bottom" asChild>
            <Button
              variation={ButtonVariation.Neutral}
              buttonSize="small"
              narrow
              onClick={onStartTour}
              data-onboarding="tasks-tour"
              aria-label="Découvrir la page Tâches"
            >
              <FontAwesomeIcon icon={faCircleQuestion} />
            </Button>
          </Tooltip>
          <Button
            variation={ButtonVariation.Secondary}
            buttonSize="small"
            data-onboarding="tasks-create"
            onClick={() =>
              setAsideAction({ action: <TaskAction defaultType="task" /> })
            }
          >
            Nouvelle tâche
            <FontAwesomeIcon icon={faPlus} />
          </Button>
        </ButtonGroup>
      </HeaderActions>
    </PageHeader>
  )
}
